import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BookedFromDeveloperConfirmModalContainer } from './BookedFromDeveloperConfirmModalContainer';
import { BookedFromDeveloperSuccessModalContainer } from './BookedFromDeveloperSuccessModalContainer/BookedFromDeveloperSuccessModalContainer';
import { closeNewbuildingBookingConfirm } from '../../actions/newbuildingBookedFromDeveloper';
import { selectIsConfirmOpen, selectIsBookingSuccess } from '../../selectors/newbuildingBookedFromDeveloper';

export const NewbuildingBookedFromDeveloperModalContainer = () => {
  const dispatch = useDispatch();
  const isOpened = useSelector(selectIsConfirmOpen);
  const isBookingSuccess = useSelector(selectIsBookingSuccess);

  const onClose = React.useCallback(() => {
    dispatch(closeNewbuildingBookingConfirm());
  }, []);

  return (
    <ModalWindow width={isBookingSuccess ? 435 : 498} open={isOpened} onClose={onClose} outside fixed={false}>
      {!isBookingSuccess && <BookedFromDeveloperConfirmModalContainer />}
      {isBookingSuccess && <BookedFromDeveloperSuccessModalContainer />}
    </ModalWindow>
  );
};
